/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Zotero_Browser_TitleInputs */

const en_zotero_browser_title = /** @type {(inputs: Zotero_Browser_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Import from Zotero`)
};

const es_zotero_browser_title = /** @type {(inputs: Zotero_Browser_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Importar desde Zotero`)
};

/**
* | output |
* | --- |
* | "Import from Zotero" |
*
* @param {Zotero_Browser_TitleInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const zotero_browser_title = /** @type {((inputs?: Zotero_Browser_TitleInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Zotero_Browser_TitleInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_zotero_browser_title(inputs)
	return en_zotero_browser_title(inputs)
});